import React from "react";
import ChartCard from "../Statistics/ChartCard.jsx";

/**
 * Rahmen für die Nutzungs-Kacheln. Anders als ChartCard aus der
 * Verkaufsstatistik (die bewusst eine "Keine Daten"-Box zeigt) gilt hier
 * die globale Vorgabe "leere Bausteine werden gar nicht gerendert" - ohne
 * Ausnahme für den Ladezustand: Solange der Stand unbekannt ist (loading),
 * bleibt die Kachel komplett weg (kein Aufblitzen einer Leer- oder
 * Lade-Box); steht fest, dass es nichts gibt, bleibt sie endgültig weg.
 * Ein Fehler wird dagegen IMMER gezeigt - das ist keine Leermeldung,
 * sondern der Hinweis, dass ein Endpunkt (noch) nicht antwortet.
 */
export default function NutzungWidget({title, help, loading, error, empty, height = 280, actions, children}) {
    if (loading) {
        return null;
    }
    if (error) {
        return <ChartCard title={title} help={help} error={error} height={height} />;
    }
    if (empty) {
        return null;
    }
    return (
        <ChartCard title={title} help={help} height={height} actions={actions}>
            {children}
        </ChartCard>
    );
}
